module.exports = __webpack_public_path__ + "img/icons-fill-invoice-2.ab2c2921.svg";